import { GlobalComponentService } from '@techmore/global';

/** 將表格的查詢參數轉換成查 API 用的查詢參數 */
export function transferTableParams2HttpListParams(queryParam: any) {
  let params: { [param: string]: string | string[]; } = {};
  if (queryParam.limit) {
    params['size'] = `${queryParam.limit}`;
  }
  if (queryParam.filter) {
    params['sfilterize'] = `${queryParam.filter}`;
  }
  if (queryParam.search) {
    params['search'] = `${queryParam.search}`;
  }
  if (queryParam.limit && (queryParam.offset || queryParam.offset === 0)) {
    params['page'] = `${queryParam.offset / queryParam.limit}`;
  }
  if (queryParam.sort && queryParam.order) {
    params['sort'] = `${queryParam.sort},${queryParam.order}`;
  }
  if (queryParam.query) {
    const query = JSON.parse(queryParam.query);
    const keys = Object.keys(query);
    if (keys.length !== 0) {
      for (const k of keys) {
        if (query[k] !== null && typeof query[k] !== 'undefined') {
          params[k] = query[k];
        }
      }
    }
  }

  return params;
}

/** 解碼jwtToken */
export function parseJwtToken(token: string) {
  const [header, payload, signature] = token.split('.');
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (base64.length + (4 - base64.length % 4)) % 4;
  const paddedBase64 = base64.padEnd(padLength, '=');
  const atobPaddedBase64 = atob(paddedBase64);
  const utf8Handler = atobPaddedBase64.split('').map(c => '%' + ('0' + c.charCodeAt(0).toString(16)).slice(-2)).join('');
  return decodeURIComponent(utf8Handler);
}

/** 當檔案上傳失敗事件拋出 */
export function onUploadFailedEvent(evt, globalComponentService: GlobalComponentService) {
  console.error(evt);

  switch (evt.code) {
    case 'E1':
      globalComponentService.openErrorAlert((evt.fileName || '') + '檔案格式錯誤');
      break;
    case 'E2':
      globalComponentService.openErrorAlert((evt.fileName || '') + '檔案大小錯誤');
      break;
    case 'E3':
      globalComponentService.openErrorAlert((evt.fileName || '') + '匯入失敗: ' + (evt.msg as Error).message);
      break;
  }
}

export const onUploadFailedEventGen = (globalComponentService: GlobalComponentService) => {
  return (evt: any) => onUploadFailedEvent(evt, globalComponentService);
};

/** 回傳範圍內的數值陣列 */
export function range(end: number, start = 0, step = 1, includeEnd = true): Array<number> {
  const size = (end - start) / step + (includeEnd ? 1 : 0);

  return Array.from({ length: size }, (_, i) => start + i * step);
}

export function isNullOrUndefined(o: any): boolean {
  return typeof o === 'undefined' || o === null;
}
